export const ROUTING_NUMBER_ERROR_MESSAGE = 'The specified routing number was not found';
export const ROUTING_NUMBER_CURRENT_ERROR_MESSAGE =
  'The payee cannot be your account at this bank. Try again.';
export const NOT_SUPPORT_WIRE_MESSAGE = "Bank doesn't support wires";
export const BANK_NOT_SUPPORT_ACH_MESSAGE = 'Bank doesn’t support ACH';
